import BaseFeature from '../../foundation/base/base';

export default class SiteDocument extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.citationImageBlobs = this.el.querySelectorAll(
			'[data-ref="citation-image-blob"]'
		);
		this.citationBgBlobs = this.el.querySelectorAll(
			'[data-ref="citation-bg-blob"]'
		);

		this.contentCardModules = this.el.querySelectorAll(
			'.o-module-content-cards-fou'
		);
		this.contentCardLists = this.el.querySelectorAll(
			'[data-ref="module-content-cards-fou__list"]'
		);
		this.contentCardList = this.el.querySelector(
			'[data-ref="module-content-cards-fou__list"]'
		);

		this.contentCardImageBlobs = this.el.querySelectorAll(
			'[data-ref="content-card-fou__image-blob"]'
		);
		this.contentCardBgBlob = this.el.querySelector(
			'[data-ref="content-card-fou__bg-blob"]'
		);
		this.contentCardBgBlobs = this.el.querySelectorAll(
			'[data-ref="content-card-fou__bg-blob"]'
		);
		this.blobStack = this.el.querySelector('.o-blob-stack');

		if (this.el.querySelector('body').classList.contains('theme-fou')) {
			this.observer = new IntersectionObserver(
				this.callbackFunction.bind(this)
			);

			this.init();
		}
	}

	init() {
		window.addEventListener('load', () => {
			if (this.blobStack) {
				this.blobStack.classList.add('o-blob-stack--slide-up');
			}
		});

		window.addEventListener('scroll', () => {
			if (
				this.citationBgBlobs.length > 0
				|| this.citationImageBlobs.length > 0
			) {
				this.citationBgBlobs.forEach((blob) => {
					this.observer.observe(blob, { threshold: 0.3 });
				});

				this.citationImageBlobs.forEach((blob) => {
					this.observer.observe(blob, { threshold: 0.3 });
				});
			}

			if (this.blobStack) {
				this.observer.observe(this.blobStack, { threshold: 0.3 });
			}

			if (this.contentCardLists.length > 0) {
				this.contentCardLists.forEach((list) => {
					if (list.children.length === 1) {
						this.observer.observe(
							list.querySelector('[data-ref="content-card-fou__image-blob"]'),
							{
								threshold: 0.3,
							}
						);
						this.observer.observe(
							list.querySelector('[data-ref="content-card-fou__bg-blob"]'),
							{ threshold: 0.3 }
						);
					}
				});
			}
		});
	}

	// eslint-disable-next-line class-methods-use-this
	callbackFunction(entries) {
		// eslint-disable-next-line array-callback-return
		entries.map((entry) => {
			if (entry.target.classList.contains('o-blob-stack')) {
				this.animateScrollingBlobStack(entry);
			}

			if (entry.target.getAttribute('data-ref') === 'citation-bg-blob') {
				this.animateCitationBgBlob(entry);
			}

			if (entry.target.getAttribute('data-ref') === 'citation-image-blob') {
				this.animateCitationImageBlob(entry);
			}

			if (
				entry.target.getAttribute('data-ref') === 'content-card-fou__image-blob'
			) {
				this.animateContentCardImageBlob(entry);
			}

			if (
				entry.target.getAttribute('data-ref') === 'content-card-fou__bg-blob'
			) {
				this.animateContentCardBgBlob(entry);
			}
		});
	}

	// eslint-disable-next-line class-methods-use-this
	animateCitationBgBlob(element) {
		if (element.isIntersecting) {
			element.target.classList.add(
				'o-module-citation__background-blob--slide-up'
			);
		} else {
			element.target.classList.remove(
				'o-module-citation__background-blob--slide-up'
			);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	animateCitationImageBlob(element) {
		if (element.isIntersecting) {
			element.target.classList.add('o-module-citation__image-blob--slide-up');
		} else {
			element.target.classList.remove(
				'o-module-citation__image-blob--slide-up'
			);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	animateContentCardImageBlob(element) {
		if (element.isIntersecting) {
			element.target.classList.add(
				'o-module-content-cards-fou--img-blob-slide-up'
			);
		} else {
			element.target.classList.remove(
				'o-module-content-cards-fou--img-blob-slide-up'
			);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	animateContentCardBgBlob(element) {
		if (element.isIntersecting) {
			element.target.classList.add(
				'o-module-content-cards-fou--bg-blob-slide-up'
			);
		} else {
			element.target.classList.remove(
				'o-module-content-cards-fou--bg-blob-slide-up'
			);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	animateScrollingBlobStack(element) {
		if (element.isIntersecting) {
			element.target.classList.add('o-blob-stack--move-up');
		} else {
			element.target.classList.remove('o-blob-stack--move-up');
		}
	}
}
